module.exports = __webpack_public_path__ + "img/9788949171029.815ad380.jpg";